module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0033.jpg?v=9d6342c6";